import React from 'react';
import ModifyReviewDialog from 'components/coaching/ModifyReviewDialog';
import CoachingReviewActions from 'actions/coaching/CoachingReviewActions';
import connectToStores from 'alt-utils/lib/connectToStores';
import AuthStore from 'stores/AuthStore';
import CoachingPlanStore from 'stores/coaching/CoachingPlanStore';
import UserStore from 'stores/UserStore';
import UserActions from 'actions/UserActions';
import CoachingPlanActions from 'actions/coaching/CoachingPlanActions';
import CoachingReviewTypeStore, {typesAndCategories} from 'stores/coaching/CoachingReviewTypeStore';
import CoachingPlaylistActions from 'actions/coaching/CoachingPlaylistActions';
import {ensureReviewMetadata} from 'components/StatsPage2.utils';

class ModifyReviewDialogContainer extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClose = this.onClose.bind(this);
    this.updateReview = this.updateReview.bind(this);
  }

  static getStores() {
    return [AuthStore, UserStore, CoachingPlanStore, CoachingReviewTypeStore];
  }

  static getPropsFromStores(props) {
    const planId = props.review && props.review.planId;
    const coaches = UserStore.getState().users.filter(u => u.canCoach());
    const [reviewTypesLoaded, reviewTypes] = typesAndCategories(CoachingReviewTypeStore);
    return {
      sessionUser: AuthStore.getState().user,
      plan: CoachingPlanStore.getState().planMap.get(planId),
      coaches,
      reviewTypes,
      reviewTypesLoaded,
      ...UserStore.getState().toObject(),
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.open && !prevProps.open) {
      const planId = this.props.review && this.props.review.planId;
      ensureReviewMetadata();
      UserActions.fetchManagersAndCoaches.defer();
      UserActions.fetchAll.defer({roles: ['admin']});
      planId && CoachingPlanActions.retrieve.defer(planId);
    }
  }

  onClose() {
    const {onRequestClose, unsetQueryParams} = this.props;
    onRequestClose();
    unsetQueryParams && unsetQueryParams(['modifyReviewId']);
  }

  updateReview(review) {
    const {refreshCoachingData, refreshUpcomingReviews} = this.props;

    const {user} = AuthStore.getState();

    return CoachingReviewActions.rescheduleReview(review).then(() => {
      refreshCoachingData && refreshCoachingData();
      refreshUpcomingReviews && refreshUpcomingReviews();
      // if we gave the review to someone else, close the playlist
      if (user.id !== review.coachUserId) {
        CoachingPlaylistActions.hide.defer();
      }
    });
  }

  render() {
    return (
      <ModifyReviewDialog
        {...this.props}
        updateReview={this.updateReview}
        onRequestClose={this.onClose}
      />
    );
  }
}

export default connectToStores(ModifyReviewDialogContainer);
